<template>
  <div class="p-fluid">
    <div class="p-grid p-formgrid">
      <div class="p-field p-col-12 p-md-6">
        <label>Transportadora *</label>
        <Dropdown
          v-model="form.carrier"
          :options="carriers"
          optionLabel="label"
          optionValue="value"
          class="p-inputtext-sm"
          appendTo="body"
          placeholder="Selecione"
        />
      </div>

      <div class="p-field p-col-12 p-md-6">
        <label>Data de Envio</label>
        <Calendar
          v-model="form.shippingDate"
          dateFormat="dd.mm.yy"
          :showIcon="true"
          inputClass="p-inputtext-sm"
          class="w-full"
        />
      </div>

      <div class="p-field p-col-12 p-md-6">
        <label>Nº Guia / Tracking</label>
        <InputText v-model="form.trackingNumber" class="p-inputtext-sm" />
      </div>

      <div class="p-field p-col-12 p-md-3">
        <label>Nº Volumes</label>
        <InputNumber v-model="form.volumes" :min="0" class="p-inputtext-sm w-full" />
      </div>

      <div class="p-field p-col-12 p-md-3">
        <label>Peso (kg)</label>
        <InputNumber
          v-model="form.weight"
          mode="decimal"
          :minFractionDigits="2"
          :maxFractionDigits="2"
          class="p-inputtext-sm w-full"
        />
      </div>

      <div class="p-field p-col-12">
        <label>Notas</label>
        <Textarea v-model="form.notes" rows="3" class="p-inputtext-sm w-full" />
      </div>
    </div>

    <div class="p-d-flex p-jc-end p-mt-3">
      <Button
        label="Cancelar"
        icon="pi pi-times"
        class="p-button-text p-mr-2"
        @click="$emit('cancel')"
      />
      <Button
        label="Guardar"
        icon="pi pi-check"
        class="p-button-success"
        :loading="saving"
        @click="save"
      />
    </div>
  </div>
</template>

<script>
import shipmentsService from "../../services/shipments.service";
import { TRANSPORTADORAS } from "../../constants/pat-options";

export default {
  name: "InternalDossierManualShipment",
  props: {
    internalDossierId: { type: [String, Number], required: true },
    defaultData: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      saving: false,
      form: {
        carrier: null,
        shippingDate: new Date(),
        trackingNumber: "",
        volumes: 1,
        weight: 0,
        notes: "",
      },
      carriers: TRANSPORTADORAS.filter((t) => t.value !== "NACEX"),
    };
  },
  mounted() {
    if (this.defaultData) {
      if (this.defaultData.carrier) {
        this.form.carrier = this.defaultData.carrier;
      }
      if (this.defaultData.reference) {
        this.form.notes = this.defaultData.reference;
      }
    }
  },
  methods: {
    async save() {
      if (!this.form.carrier) {
        this.$toast.add({
          severity: "warn",
          summary: "Aviso",
          detail: "Selecione uma transportadora.",
          life: 3000,
        });
        return;
      }

      this.saving = true;
      try {
        const payload = {
          internal_dossier_id: this.internalDossierId,
          provider: this.form.carrier,
          type: "shipment",
          tracking_number: this.form.trackingNumber,
          shipping_date: this.formatDate(this.form.shippingDate),
          volumes: this.form.volumes,
          weight: this.form.weight,
          notes: this.form.notes,
        };

        await shipmentsService.createManualShipment(payload);
        this.$emit("success");
      } catch (err) {
        this.$toast.add({
          severity: "error",
          summary: "Erro",
          detail:
            err.response?.data?.error || "Erro ao criar expedição manual.",
          life: 5000,
        });
      } finally {
        this.saving = false;
      }
    },
    formatDate(date) {
      if (!date) return null;
      const d = new Date(date);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
    },
  },
};
</script>

<style scoped>
.w-full {
  width: 100%;
}
</style>
